export const cookieCategories = {
  essential: ["firestore", "mailchimp", "gmap_geocoding"],
  analytical: [
    "firebase_analytics",
    "google_analytics",
    "gtm",
    "retarget_online_ads",
    "microsoft_clarity",
    "facebook_app_events",
    "meta_pixel",
  ],
  marketing: [
    "google_ads",
    "google_aa",
    "facebook_pixel",
    "google_ads_conversion_tracking",
  ],
};
